import React, {useEffect} from 'react';

const EnterReroute = ({ids_list}) => {

  const enterReroute = ({id = '', click_id = ''}) => {
    document.getElementById(id).addEventListener('keypress', e => {
      if (e.key === 'Enter') {
        e.preventDefault(); // to block page 'form' from submiting
        // optional click action
        if (click_id === '') { return }
        document.querySelector(click_id).click();
      }
    });
  }

  useEffect(() => {
    ids_list.forEach(ids => {
      if(!ids.hasOwnProperty('id')){
        console.log('Element id missing on enter_relay component');
        return
      }
      enterReroute(ids);
    });
  }, []);

  return null;
};

export default EnterReroute;
